import { cn } from "@/lib/utils";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "@radix-ui/react-collapsible";
import { ChevronDown } from "lucide-react";
import { useRef } from "react";

const FormSection = ({
  title,
  isCollapsible,
  defaultOpen,
  children,
}: {
  title: string;
  isCollapsible?: boolean;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) => {
  const collapsibleRef = useRef<HTMLDivElement>(null);
  const { scrollHeight: parentScrollHeight = 0, offsetHeight: parentOffsetHeight = 0 } =
    collapsibleRef?.current?.parentElement || {};
  return (
    <Collapsible ref={collapsibleRef} defaultOpen={defaultOpen}>
      <CollapsibleTrigger
        className={cn(
          "flex w-full h-12 bg-white z-30 text-left",
          !isCollapsible ? "cursor-default" : "[&[data-state=open]>svg]:rotate-180",
          parentScrollHeight > Math.min(parentOffsetHeight, window.screen.height) && "sticky top-0",
        )}>
        <h1 className="text-xl font-bold">{title}</h1>
        {isCollapsible && <ChevronDown className="ml-2 font-bold" />}
      </CollapsibleTrigger>
      {isCollapsible ? (
        <CollapsibleContent>
          <div className="flex flex-col flex-nowrap">{children}</div>
        </CollapsibleContent>
      ) : (
        <div className="flex flex-col flex-nowrap">{children}</div>
      )}
    </Collapsible>
  );
};

export default FormSection;
